class SoundManager {
  constructor() {
    this.sounds = {};
    this.enabled = true;
  }

  // Load sound
  load(name, path) {
    this.sounds[name] = new Audio(path);
    this.sounds[name].preload = 'auto';
  }

  // Play sound
  play(name, volume = 0.5) {
    if (!this.enabled || !this.sounds[name]) return;
    
    const sound = this.sounds[name].cloneNode();
    sound.volume = Math.min(Math.max(volume, 0), 1);
    sound.play().catch(err => console.log('Audio play failed:', err));
  }

  // Toggle sound on/off
  toggle() {
    this.enabled = !this.enabled;
    return this.enabled;
  }

  // Set enabled state
  setEnabled(enabled) {
    this.enabled = enabled;
  }
}

// Create singleton instance
export const soundManager = new SoundManager();

// Preload all sounds
soundManager.load('wind', '/sounds/wind.mp3');
soundManager.load('tick', '/sounds/tick.mp3');
soundManager.load('gear', '/sounds/gear.mp3');
soundManager.load('ui-click', '/sounds/ui-click.mp3');
soundManager.load('whoosh', '/sounds/whoosh.mp3');